import { render, staticRenderFns } from "./OrderItemsList.vue?vue&type=template&id=adaf6c40&"
import script from "./OrderItemsList.vue?vue&type=script&lang=js&"
export * from "./OrderItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports